import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/Index";
import { publicToolHead } from "@/lib/publicToolRoutes";

const Page = () => <Index toolKey="posts" routeLang="es" />;

export const Route = createFileRoute("/publicaciones-para-tu-local")({
  head: () => publicToolHead("posts", "es"),
  component: Page,
  errorComponent: Page,
  notFoundComponent: Page,
});
